import { mediaQueryTests } from "./media-query-tests";
import type { MediaQueriesStoreState } from "./types";
import { create } from "@fhs/zustand";
import { Dimensions } from "react-native";

export const useMediaQueries = create<MediaQueriesStoreState>(() => ({
  $base: true,

  $sm: false,
  $gtSm: false,

  $md: false,
  $gtMd: false,

  $lg: false,
  $gtLg: false,

  $xl: false,
  $gtXl: false,
}));

const mediaQueryKeys = Object.keys(mediaQueryTests) as Array<keyof typeof mediaQueryTests>;

Dimensions.addEventListener("change", ({ window: dimensions }) => {
  requestAnimationFrame(() => {
    const mediaQueries = {};

    for (const queryKey of mediaQueryKeys) {
      mediaQueries[queryKey] = mediaQueryTests[queryKey](dimensions);
    }

    useMediaQueries.setState(mediaQueries, true);
  });
});
